import { render, staticRenderFns } from "./Trafficlight.vue?vue&type=template&id=0b418594&scoped=true&"
import script from "./Trafficlight.vue?vue&type=script&lang=js&"
export * from "./Trafficlight.vue?vue&type=script&lang=js&"
import style0 from "./Trafficlight.vue?vue&type=style&index=0&id=0b418594&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b418594",
  null
  
)

export default component.exports